module.exports = __webpack_public_path__ + "static/img/so5_2.fc15590.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so5_2.jpg
// module id = JzIh
// module chunks = 11